import CbInputGroupAddon from './src/input-group-addon.vue';

CbInputGroupAddon.install = function(Vue) {
  Vue.component(CbInputGroupAddon.name, CbInputGroupAddon);
};

export default CbInputGroupAddon;
